import React from "react";
import Booking, {resetForm, setError, setMember} from './modal/Booking'
import MembersBooking from './modal/MembersBooking'
import {AppStore, setBookings} from "../useAppPullState";
import {useSelector} from "react-redux";
import {Store} from "pullstate";

export const ModalStore = new Store({
    showModal: false,
    showMemberModal: false,
});

export const NewBooking = () => {
    const {
        data,
        user,
    } = AppStore.useState(s => ({
        data: s.selected,
        user: s.user,
    }))
    const bookings = useSelector(state => state.bookings.bookings);
    const {showMemberModal} = ModalStore.useState();
    const openMemberModal = (isOpen) => () => {
        ModalStore.update(s => {
            s.showMemberModal = isOpen;
            if(isOpen === false) {
                s.selected = null;
                setError(null);
                setMember(null)
                resetForm();
            }
        });
    }

    const setData = (data) => {
        AppStore.update(s => {
            s.selected = data;
        })
    }

    const isLocationAdmin = user?.roleId === 2;
    const BookingComponent = isLocationAdmin ? Booking : MembersBooking;
    return (
        <>
            {data && (
                <BookingComponent
                    course={data.item}
                    data={data}
                    setData={setData}
                    handleOpenModal={openMemberModal(true)}
                    handleCloseModal={openMemberModal(false)}
                    showModal={showMemberModal}
                    setBookings={setBookings}
                    booking={bookings}
                    socket={{}}
                />
            )}
        </>
    )
}
